import { useQuery } from '@tanstack/react-query';
import { getGeneralInformationById } from 'api/auth.api';

export const useGeneralInformationById = (id) => {
  return useQuery({
    queryKey: ['generalInformationById', id],
    queryFn: () => getGeneralInformationById(id),
    enabled: !!id,
  });
};
